<template>
  <div class="home">
    <div class="main mplus bg" :class="[channelName, { show: this.keysok }]" id="main">
      <div class="bg1-box box" id="box">
        <div class="present-box box" id="present" :class="channelName">

          <div class="present-title josefin title-text" :class="channelName">
            present
          </div>
          <div class="head">
            <div class="mplus jp"><span class="bolder">ジュエルステージ「オンエア！」<br />
                〜Unit Story side <span v-html="title"></span>〜</span><br />
              ご来場いただきまして誠にありがとうございます。<br />
              <span v-html="title"></span>から特待生へサプライズのお届けです！<br />
              ぜひ待ち受け画面に設定してください！<br />
            </div>
          </div>
          <div class="img-box">
            <img :src="thumbsFileName" alt="" class="wallpaper-image">
          </div>
          <div class="text-howto">
            <span class="bolder">［ 画像のダウンロード方法 ］</span><br />
            １. 「ダウンロード」ボタンを押します。<br />
            ２. 画像が表示されます。<br />
            ３. 表示された画像をタッチで｢長押し｣し、<br />ポップアップウィンドウ内の［画像を保存］を選択します。<br />
            ※Androidは［画像をダウンロード］を選択<br />
          </div>
          <div class="button"><a :href="imageFileName"><span class="text" :class="channelName">ダウンロード</span></a></div>
          <div class="footer-copyright mplus">©coly／ジュエルステージ<span class="kakko2">「オンエア<span
                class="kakko2">！</span>」</span>製作委員会
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {

  name: 'Present',
  props: [

  ],
  data: () => ({
    k2ch: { "e": "emekare", "m": "maisy", "r": "refly" },
    n2maru: { 1: "①", 2: "②" },
    k2name: { "e": "エメ☆カレ", "m": "MAISY", "r": "Re:Fly" },
    exists: false
  }),
  mounted: function () {
    const http = axios.create({
    });
    http.head(this.thumbsFileName).then(response => {
      this.exists = false
      if (response.headers['content-type'].match('image/jpeg')) {
        this.exists = true
      }
    }).catch((reason) => {
      if (reason.response.status === 404) {
        this.exists = false
      }
      if (reason.response.headers['content-type'].match('text/html')) {
        this.exists = false
      }
    })
  },
  computed: {
    key() {
      return this.$route.params.key;
    },
    channel() {
      let key = this.$route.params.key;
      let ch = key.slice(0, 1);
      return ch;
    },
    channelName() {
      let key = this.$route.params.key;
      let ch = key.slice(0, 1);
      return this.k2ch[ch];
    },
    channelBg() {
      let channel = this.channelName;
      return `${channel}Bg`;
    },
    imageFileName() {
      let key = this.$route.params.key;
      return `../img/wallpaper/${key}.jpg`;
    },
    imageFileNameClean() {
      let key = this.$route.params.key;
      let ch = key.slice(0, 1);
      let chName = this.k2ch[ch];
      let num = key.slice(1, 2);
      let wpNum = parseInt((num - 1) / 3, 10) + 1;
      return `MRE-${chName}${wpNum}.jpg`;
    },
    thumbsFileName() {
      let key = this.$route.params.key;
      return `../img/wallpaper/thumbs/${key}_thumbnail.jpg`;
    },
    title() {
      let key = this.$route.params.key;
      let ch = key.slice(0, 1);
      let name = this.k2name[ch];
      return name;
    },
    keysok() {
      if (this.exists === false) {
        return false
      }
      let key = this.$route.params.key;
      let ch = key.slice(0, 1);
      let num = key.slice(1, 2);
      let wpNum = parseInt((num - 1) / 3, 10) + 1;
      if (ch.match(/m|r|e/) && (wpNum === 2 || wpNum === 1)) {
        return true;
      }
      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  position: relative;
  min-height: 100vh;
  display: none;

  @media screen and (max-width: 768px) {
    background-size: 200% auto !important;
    background-position: 50% 0 !important;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  &.show {
    display: block;
  }

  &.maisy {
    background: url(../../public/img/maisy/haikei_maisy.jpg) repeat;
    background-size: 100% auto;
    background-position: 0 0;
    background-attachment: fixed;
  }

  &.refly {
    background: url(../../public/img/refly/haikei_refly.jpg) repeat;
    background-size: 100% auto;
    background-position: 0 0;
    background-attachment: fixed;
  }

  &.emekare {
    background: url(../../public/img/emekare/haikei_emekare.jpg) repeat;
    background-size: 100% auto;
    background-position: 0 0;
    background-attachment: fixed;
  }

  .bg1-box {
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;

    @media screen and (max-width: 768px) {
      padding: 1rem 0;
    }
  }

  .present-box {
    border: 1px solid $liteorange;
    padding: 0;
    background-color: $white-op5;
    display: flex;
    flex-direction: column;

    &.refly {
      border-color: $liteblue;
    }

    &.emekare {
      border-color: $litegreen;
    }
  }



  .present-title {
    padding-top: 5rem;
    font-size: 2.6 * $rem;
    text-align: center;
    font-weight: 600;
    position: relative;
    color: $orange;
    text-transform: uppercase;

    @media screen and (max-width: 768px) {
      padding-top: 2rem;
      font-size: 1.8rem;
    }

    @media screen and (min-width: 1024px) {
      font-size: 2.6rem;
    }

    &::before,
    &::after {
      position: absolute;
      content: "";
      background: url(../../public/img/maisy/title_maisy.png) no-repeat;
      width: 44px;
      height: 68px;
      bottom: -8px;
      left: 4 * $rem;

      @media screen and (min-width: 1024px) {
        left: 4rem;
      }

      @media screen and (max-width: 768px) {
        left: 0;
        background-size: calc(44px * .8) calc(68px * .8);
        height: calc(68px * .8);
      }
    }

    &.refly {
      color: $blue;

      &::before,
      &::after {
        background: url(../../public/img/refly/title_refly.png) no-repeat;
        width: 44px;
        height: 68px;
        bottom: -8px;
        left: 4 * $rem;

        @media screen and (min-width: 1024px) {
          left: 4rem;
        }

        @media screen and (max-width: 768px) {
          left: 0;
          background-size: calc(44px * .8) calc(68px * .8);
          height: calc(68px * .8);
        }
      }
    }

    &.emekare {
      color: $green;

      &::before,
      &::after {
        background: url(../../public/img/emekare/title_emekare.png) no-repeat;
        width: 44px;
        height: 68px;
        bottom: -8px;
        left: 4 * $rem;

        @media screen and (min-width: 1024px) {
          left: 4rem;
        }

        @media screen and (max-width: 768px) {
          left: 0;
          background-size: calc(44px * .8) calc(68px * .8);
          height: calc(68px * .8);
        }
      }
    }

    &.refly::after,
    &.emekare::after,
    &::after {
      transform: scaleX(-1);
      right: 4 * $rem;
      left: unset;

      @media screen and (min-width: 1024px) {
        right: 4rem;
      }

      @media screen and (max-width: 768px) {
        right: 0;
      }
    }
  }

  .head {
    color: black;
    font-size: 0.9rem;
    margin-top: 2rem;
    font-weight: 400;
    line-height: 1.7;
    margin-bottom: 1rem;
  }

  .text-howto {
    color: black;
    font-size: 0.8rem;
    margin-top: 2rem;
    font-weight: 400;
    line-height: 1.8;
    margin-bottom: 1rem;
  }
}

.img-box {
  padding-top: 1rem;
  width: 35%;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    width: 65%;
  }

  .wallpaper-image {
    width: 100%;
    height: auto;
    aspect-ratio: 2/3;

  }
}

.button {
  margin: 0 auto;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 1.1rem;
  margin-bottom: auto;

  .text {
    margin-top: 2rem;
    padding: 0.4rem 2rem;
    background-color: $liteorange;
    color: white;
    font-weight: 600;
    border-radius: 1.5rem;
    font-size: 1.1rem;
    transition: 0.33s;

    &:hover {
      background-color: white;
      color: $liteorange;
    }

    &.emekare {
      background-color: $litegreen;

      &:hover {
        background-color: white;
        color: $litegreen;
      }
    }

    &.refly {
      background-color: $liteblue;

      &:hover {
        background-color: white;
        color: $liteblue;
      }
    }

  }
}


.footer-copyright {
  font-size: 0.5rem;
  padding-top: 0.5rem;
  font-weight: 400;
  margin-bottom: 1.3rem;
  color: black;
  padding-bottom: 1rem;

  @media screen and (max-width: 768px) {
    padding-top: 1rem;
    margin-bottom: 0;
    margin-left: auto;
    margin-right: auto;
  }
}

.bg {
  background-size: 200% auto;
  background-position: 50% 0;
}
</style>